// IframeEmbed.jsx
import React, { useMemo } from "react";

const IframeEmbed = ({ url, onLoad }) => {
  // sanitize simple issues (remove stray quotes, trim)
  const cleaned = useMemo(() => {
    if (!url) return "";
    // remove quotes and whitespace
    let u = String(url).trim().replace(/['"]+/g, "");
    // if user passed a hash-only fragment or missing protocol, ensure it has protocol
    if (!/^https?:\/\//i.test(u)) {
      u = "https://" + u;
    }
    return u;
  }, [url]);

  if (!cleaned) {
    return <div>Invalid URL</div>;
  }

  return (
    <div style={{ width: "100%", height: "100%", minHeight: 400 }}>
      <iframe
        src={cleaned}
        onLoad={onLoad}
        title="Embedded App"
        allow="fullscreen"
        sandbox="
    allow-same-origin
    allow-scripts
    allow-forms
    allow-popups
    allow-modals
    allow-downloads
  "
        referrerPolicy="no-referrer"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          minHeight: "600px",
        }}
      />


    </div>
  );
};

export default IframeEmbed;
